/**
 * @generated SignedSource<<6fadf3fcc40c9c26e65013579ca33d25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SkillResult = "ALMOST_THERE" | "DEMONSTRATED" | "KEEP_LEARNING" | "NOT_STARTED" | "PASSED" | "PLACED_OUT" | "REVIEW" | "%future added value";
export type SingleUnitSkillProgressQuery$variables = {
  classIds: ReadonlyArray<string>;
  targetIds: ReadonlyArray<string>;
};
export type SingleUnitSkillProgressQuery$data = {
  readonly skillProgress: ReadonlyArray<{
    readonly skill: {
      readonly id: string;
      readonly name: string | null | undefined;
    };
    readonly usersBySkillResults: ReadonlyArray<{
      readonly key: SkillResult;
      readonly value: ReadonlyArray<{
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
        readonly publicUserId: string | null | undefined;
      }>;
    }>;
  }>;
};
export type SingleUnitSkillProgressQuery = {
  response: SingleUnitSkillProgressQuery$data;
  variables: SingleUnitSkillProgressQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "classIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetIds"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "classIds",
        "variableName": "classIds"
      },
      {
        "kind": "Variable",
        "name": "targetIds",
        "variableName": "targetIds"
      }
    ],
    "concreteType": "SkillProgress",
    "kind": "LinkedField",
    "name": "skillProgress",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillNode",
        "kind": "LinkedField",
        "name": "skill",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "KeyValuePairOfSkillResultAndIEnumerableOfUser",
        "kind": "LinkedField",
        "name": "usersBySkillResults",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "value",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publicUserId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SingleUnitSkillProgressQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SingleUnitSkillProgressQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "57325c724ef186981bb450e6c10b037d",
    "id": null,
    "metadata": {},
    "name": "SingleUnitSkillProgressQuery",
    "operationKind": "query",
    "text": "query SingleUnitSkillProgressQuery(\n  $classIds: [ID!]!\n  $targetIds: [ID!]!\n) {\n  skillProgress(classIds: $classIds, targetIds: $targetIds) {\n    skill {\n      id\n      name\n    }\n    usersBySkillResults {\n      key\n      value {\n        id\n        firstName\n        lastName\n        publicUserId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab8886935cabc12e2dffdbb680cb7552";

export default node;
